import { ArrowUpDown, Filter } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useListeningConfig } from '@/hooks/use-social-listening'
import type {
  MentionFilters as MentionFiltersType,
  MentionSortBy,
} from '@/lib/api/modules/social-listening'

type Props = {
  filters: MentionFiltersType
  onChange: (filters: MentionFiltersType) => void
}

export function MentionFilters({ filters, onChange }: Props) {
  const { data: config } = useListeningConfig()
  const hashtags = (config?.hashtagsToTrack as string[] | undefined) || []

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Filter className="h-4 w-4 text-muted-foreground" />

      <Select
        value={filters.hashtag || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, hashtag: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-44">
          <SelectValue placeholder="Hashtag" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos perfis</SelectItem>
          {hashtags.map((tag) => (
            <SelectItem key={tag} value={tag}>
              @{tag}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.status || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, status: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-36">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos status</SelectItem>
          <SelectItem value="new">Nova</SelectItem>
          <SelectItem value="reviewed">Revisada</SelectItem>
          <SelectItem value="linked">Vinculada</SelectItem>
          <SelectItem value="ignored">Ignorada</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.platform || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, platform: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-36">
          <SelectValue placeholder="Rede social" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas redes</SelectItem>
          <SelectItem value="instagram">Instagram</SelectItem>
          <SelectItem value="tiktok">TikTok</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.mediaType || 'all'}
        onValueChange={(v) =>
          onChange({ ...filters, mediaType: v === 'all' ? undefined : v, page: 1 })
        }
      >
        <SelectTrigger className="w-36">
          <SelectValue placeholder="Tipo de post" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos tipos</SelectItem>
          <SelectItem value="image">Imagem</SelectItem>
          <SelectItem value="video">Vídeo</SelectItem>
          <SelectItem value="carousel">Carrossel</SelectItem>
        </SelectContent>
      </Select>

      <div className="flex items-center gap-1.5 ml-auto">
        <ArrowUpDown className="h-3.5 w-3.5 text-muted-foreground" />
        <Select
          value={filters.sortBy || 'postedAt_desc'}
          onValueChange={(v) => onChange({ ...filters, sortBy: v as MentionSortBy, page: 1 })}
        >
          <SelectTrigger className="w-44">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="postedAt_desc">Mais recente</SelectItem>
            <SelectItem value="postedAt_asc">Mais antigo</SelectItem>
            <SelectItem value="likes_desc">Mais curtidas</SelectItem>
            <SelectItem value="comments_desc">Mais comentários</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
